import PortalIdParser from 'PortalIdParser';
import ReviewFilters from '../records/ReviewFilters';
import { useReviews } from './useReviews';
export function useGetPreviousReviews({
  appContext,
  entityId,
  reviewType,
  reviewerUserId
}) {
  const {
    reviews,
    reviewsFetchStatus
  } = useReviews({
    appContext,
    offeringId: entityId,
    reviewFilters: new ReviewFilters({
      reviewTypes: [reviewType],
      entityId: appContext === 'public' ? undefined : entityId,
      reviewerPortalId: PortalIdParser.get(),
      reviewerUserId
    }),
    reviewType
  });
  return {
    reviews,
    reviewsFetchStatus
  };
}